// INVOICE DATA
export const INVOICE_DATA_LOADED = 'INVOICE_DATA_LOADED';

// MODALS
export const SHOW_ERROR_MODAL = 'SHOW_ERROR_MODAL';

// PAYMENTS
export const TOGGLE_PAYMENT_PROCESSING = 'TOGGLE_PAYMENT_PROCESSING';
